import { render, staticRenderFns } from "./Mergado.vue?vue&type=template&id=84f7deba&"
import script from "./Mergado.vue?vue&type=script&lang=js&"
export * from "./Mergado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports